/**
 *
 * HealthCheckUpTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ProductivityIcon from 'assets/v2/ProductivityIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.skyBlue};
    }
  }
`;

function HealthCheckUpTag(props) {
  return (
    <StyledTag label="Health Check-Up" icon={<ProductivityIcon />} {...props} />
  );
}

export default memo(HealthCheckUpTag);
